import { clsx } from 'clsx';
import { SmartLink } from '@shared/lib/routing';
import { tw } from '@shared/lib/tw';
import { useIntervalIndex } from '../../model/useIntervalIndex';
import { INTERVAL } from '../../config/constants';
import type { IMenuElement } from '../../model/types';
import { Icon } from '../icon/Icon';
import styles from './desktopMenu.module.css';

export function DesktopMenu({
  mainDomain,
  menuList,
}: {
  mainDomain: string;
  menuList: IMenuElement[];
}) {
  const menu = menuList.filter(({ visible }) => visible);
  const animatedIndex = useIntervalIndex(menu.length, INTERVAL);
  return (
    <div className="flex h-full flex-1 flex-col justify-start bg-white-translucent">
      {menu.map((item, index) => (
        <SmartLink
          href={`/menu/${item.text_id}`}
          className={clsx(
            styles.animateUpDown,
            `group relative flex max-h-20 min-h-[50px] flex-1 items-center justify-center
            fill-(--tundora) hover:bg-(--hover-menu)`,
          )}
          activeClassName={tw('**:fill-(--common-2)! **:stroke-(--common-2)!')}
          key={item.text_id}
        >
          <Icon
            width={45}
            height={45}
            item={item}
            mainDomain={mainDomain}
            className={clsx(
              `group-hover:fill-white! group-hover:stroke-white! group-hover:**:fill-white!
              group-hover:**:stroke-white! max-[1450px]:h-10 max-[1450px]:w-10`,
              {
                'rotate-y-360 transition-transform duration-1200':
                  index === animatedIndex,
              },
            )}
          />
          <div
            className="invisible absolute left-0 flex h-full min-w-60 items-center
              rounded-(--desktop-menu-description-border-radius) px-5 opacity-0
              group-hover:visible group-hover:left-20 group-hover:bg-(--hover-menu)
              group-hover:opacity-100 group-hover:transition-all group-hover:duration-200"
          >
            <span className="text-xl/tight text-white uppercase">
              {item.title}
            </span>
          </div>
        </SmartLink>
      ))}
    </div>
  );
}
